// Module
var code = `<tour-step-body><span translate="custom-sort-tour_body"></span></tour-step-body>`;
// Exports
export default code;